// src/client/pages/AccountClient.jsx
import React, { useEffect, useState } from 'react';
import { useCart } from '../../core/context/CartContext';
import api from '../../core/api';

const AccountClient = () => {
  const [orders, setOrders] = useState([]);
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState('Chargement...');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const { addToCart, clearCart } = useCart();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const clientKey = localStorage.getItem('selectedClient') || 'le_resto_local';

        const resOrders = await api.get(`/api/orders/my`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'x-client-key': clientKey,
          },
        });

        const userData = JSON.parse(localStorage.getItem('user'));

        if (!Array.isArray(resOrders.data)) {
          throw new Error('Réponse invalide : attendue une liste de commandes.');
        }

        setOrders(resOrders.data);
        setUser(userData);
        setStatus(resOrders.data.length === 0 ? 'Aucune commande trouvée.' : '');
      } catch (err) {
        console.error('❌ Erreur récupération commandes :', err.response?.data || err.message);
        setStatus('Erreur lors du chargement des commandes.');
      }
    };

    fetchData();
  }, []);

  const openModal = (order) => setSelectedOrder(order);
  const closeModal = () => setSelectedOrder(null);

  const handleRepeatOrder = (items) => {
    if (!Array.isArray(items)) {
      return alert('❌ Produits indisponibles pour cette commande.');
    }

    clearCart();
    items.forEach((item) => {
      addToCart({
        name: item.name,
        price: item.price,
        image: item.image || '',
        _id: item._id || Math.random().toString(),
        quantity: item.quantity,
      });
    });
    alert('Commande ajoutée au panier.');
  };

  const handleDownloadPDF = async (orderId) => {
    try {
      const token = localStorage.getItem('token');
      const clientKey = localStorage.getItem('selectedClient') || 'le_resto_local';

      const response = await api.get(`/api/orders/${orderId}/pdf`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
          'x-client-key': clientKey,
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `ticket-${orderId.slice(-6)}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url)
    } catch (err) {
      console.error('❌ Erreur téléchargement PDF :', err.response?.data || err.message);
      alert('Erreur lors du téléchargement du PDF.');
    }
  };

  return (
    <div className="container my-5">
      <h2 className="mb-4">Mon compte</h2>

      {user && (
        <p className="mb-3">
          <strong>Points fidélité :</strong> {user.points || 0}
        </p>
      )}

      <h4 className="mb-3">Mes commandes</h4>
      {status && <p>{status}</p>}

      {orders.map((order) => (
        <div key={order._id} className="card mb-4 shadow-sm">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Commande #{order._id.slice(-6)}</h5>
            <span className="badge bg-secondary">{order.status}</span>
          </div>

          <div className="card-body">
            <p><strong>Date :</strong> {new Date(order.createdAt).toLocaleString()}</p>
            <p><strong>Total :</strong> {(Number(order.total || 0)).toFixed(2)} €</p>

            <div className="d-flex flex-wrap gap-2 mt-3">
              <button className="btn btn-outline-primary" onClick={() => openModal(order)}>Détails</button>
              <button className="btn btn-success" onClick={() => handleRepeatOrder(order.items)}>Répéter</button>
              <button className="btn btn-secondary" onClick={() => handleDownloadPDF(order._id)}>Télécharger PDF</button>
              <a href={`/suivi/${order.trackingId}`} className="btn btn-outline-dark">Suivre la commande</a>
            </div>
          </div>
        </div>
      ))}

      {selectedOrder && (
        <div className="modal show d-block" tabIndex="-1" role="dialog" onClick={closeModal} style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="modal-dialog modal-lg" role="document" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Commande #{selectedOrder._id.slice(-6)}</h5>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                <p><strong>Date :</strong> {new Date(selectedOrder.createdAt).toLocaleString()}</p>
                <p><strong>Statut :</strong> {selectedOrder.status}</p>
                <p><strong>Type :</strong> {selectedOrder.orderType}</p>
                <p><strong>Nom :</strong> {selectedOrder.name}</p>
                <p><strong>Email :</strong> {selectedOrder.email}</p>
                <p><strong>Téléphone :</strong> {selectedOrder.phone}</p>
                <p><strong>Adresse :</strong> {selectedOrder.address}</p>
                <p><strong>Notes :</strong> {selectedOrder.notes}</p>
                <hr />
                <h6>Produits commandés :</h6>
                {Array.isArray(selectedOrder.items) ? (
                  <ul className="list-group">
                    {selectedOrder.items.map((item, idx) => (
                      <li key={idx} className="list-group-item d-flex justify-content-between">
                        <span>{item.name} × {item.quantity}</span>
                        <span>{(item.price * item.quantity).toFixed(2)} €</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-danger">⚠️ Impossible de charger les produits de cette commande.</p>
                )}
                <hr />
                <p><strong>Total :</strong> {(Number(selectedOrder.total || 0)).toFixed(2)} €</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>Fermer</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountClient;
